import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Exams|Survey Items';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

const columnHeadingStart = 'Column heading for: ';

type LocNameStart = 'SPCandidateExamSurveyItems';
export type SPCandidateExamSurveyItemsLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelTitle`
	| `${LocNameStart}LabelTimeSpent`
	| `${LocNameStart}LabelResponseType`
	| `${LocNameStart}LabelResponse`
	| `${LocNameStart}LabelTimeSpentTotal`
	| `${LocNameStart}LabelSummaryRow`;

export const spCandidateExamSurveyItemsLocs: LocDefs<SPCandidateExamSurveyItemsLocNames> = {
	SPCandidateExamSurveyItemsTitlePage: {
		defaultValue: 'Survey Items',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Exam/CandidateExamSurvey.Title.SectionDetails',
		...sharedProperties,
	},
	SPCandidateExamSurveyItemsTitleTab: {
		defaultValue: 'Survey Items',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Exam/CandidateExamSurvey.Title.Tab',
		...sharedProperties,
	},
	SPCandidateExamSurveyItemsLabelName: {
		defaultValue: 'Name',
		description: `${columnHeadingStart}Name`,
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Exam/CandidateExamSurvey.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateExamSurveyItemsLabelTitle: {
		defaultValue: 'Title',
		description: `${columnHeadingStart}Title`,
		displayPath: `${pathStart}Title`,
		displayType: 'Label',
		legacyName: 'Exam/CandidateExamSurvey.ColumnHeading.Title',
		...sharedProperties,
	},
	SPCandidateExamSurveyItemsLabelTimeSpent: {
		defaultValue: 'Time Spent',
		description: `${columnHeadingStart}Time Spent`,
		displayPath: `${pathStart}Time Spent`,
		displayType: 'Label',
		legacyName: 'Exam/CandidateExamSurvey.ColumnHeading.TimeSpent',
		...sharedProperties,
	},
	SPCandidateExamSurveyItemsLabelResponseType: {
		defaultValue: 'Response Type',
		description: `${columnHeadingStart}Response Type`,
		displayPath: `${pathStart}Response Type`,
		displayType: 'Label',
		legacyName: 'Exam/CandidateExamSurvey.ColumnHeading.ResponseType',
		...sharedProperties,
	},
	SPCandidateExamSurveyItemsLabelResponse: {
		defaultValue: 'Response',
		description: `${columnHeadingStart}Response`,
		displayPath: `${pathStart}Response`,
		displayType: 'Label',
		legacyName: 'Exam/CandidateExamSurvey.ColumnHeading.Response',
		...sharedProperties,
	},
	SPCandidateExamSurveyItemsLabelTimeSpentTotal: {
		defaultValue: 'Total Time Spent',
		description: `Label for the Total Time Spent.`,
		displayPath: `${pathStart}Total Time Spent`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateExamSurveyItemsLabelSummaryRow: {
		defaultValue: 'Total',
		description: `Label for the summary row.`,
		displayPath: `${pathStart}Total`,
		displayType: 'Label',
		...sharedProperties,
	},
};

export type SPCandidateExamSurveyItemsLocType = LocMap<SPCandidateExamSurveyItemsLocNames>;
